<template>
    <div class="member-withdraw member-tab">
        <!-- <div class="alarm" v-if="verifiedState != 5">
            <span v-if="verifiedState == 1">您必須先通過認證房東，才能新增銀行卡。<router-link :to="{ name: 'MemberCenter'}">認證房東  <img src="../../../../assets/img/icon/arrow_right_orange.svg" alt=""></router-link></span>
            <span v-if="verifiedState == 2">資料未填</span>
            <span v-if="verifiedState == 3">資料已填但未上傳證件</span>
            <span v-if="verifiedState == 4">房東認證中，審核完成即可新增銀行卡</span>
            <span v-if="verifiedState == 6">審查未通過</span>
            <span v-if="verifiedState == 7">帳號停用</span>
        </div> -->
        <platform-fee-info></platform-fee-info>
        <div class="member-withdraw-wrap">
            <div class="member-withdraw-head" :class="{'fixed': listIsFixed}">
                <span class="title">飛豬錢包</span>
                <ul class="wallet-tab">
                    <li :class="{active: walletSelectedTab == walletTabName.stored}" @click="walletSelectedTab = walletTabName.stored">儲值紀錄</li>
                    <li :class="{active: walletSelectedTab == walletTabName.recived}" @click="walletSelectedTab = walletTabName.recived">收款帳戶</li>
                    <li :class="{active: walletSelectedTab == walletTabName.withdraw}" @click="walletSelectedTab = walletTabName.withdraw">提領紀錄</li>
                    <li :class="{active: walletSelectedTab == walletTabName.income}" @click="walletSelectedTab = walletTabName.income">收益紀錄</li>
                </ul>
                <div class="platform-fee" @click="platformFeeEvent()">
                    <img src="@/assets/img/icon/info_gray.svg" alt="" srcset="" @mouseenter="infoShow = 1" @mouseleave="infoShow = 0">
                    <span class="info">如何收費？</span>
                </div>
                <!-- <span class="info">
                    <img src="../../../../assets/img/icon/info_gray.svg" alt="">
                    在你的飛豬管家帳戶與連結的銀行帳戶之間進行提領
                </span> -->
                <!-- <div class="btn-group" v-if="verifiedState == 5">
                    <rent-select refName="bankCard" selectMsg="所有狀態" @getId="getSelectId" border="1px solid #d5dad8" bgColor="#fff" :setDefault="isDefault">
                        <ul>
                            <li data-id="NORMAL">審核通過</li>
                            <li data-id="REJECT">審核失敗</li>
                            <li data-id="UNDER_REVIE">審核中</li>
                        </ul>
                    </rent-select>
                </div> -->
            </div>
            <div class="member-withdraw-body" >
                <stored-record v-if="walletSelectedTab == walletTabName.stored"></stored-record>
                <recived-account v-if="walletSelectedTab == walletTabName.recived"></recived-account>
                <withdraw-record v-if="walletSelectedTab == walletTabName.withdraw"></withdraw-record>
                <income-record v-if="walletSelectedTab == walletTabName.income"></income-record>
               <!--  <new-bank :bankCardState="bankCardState"></new-bank>
            </div>
            <div class="member-withdraw-head" v-if="verifiedState == 5">
                <span class="title">提領紀錄</span>
                <div class="btn-group">
                    <rent-select refName="withdraw" selectMsg="所有狀態" @getId="getSelectId" border="1px solid #d5dad8" bgColor="#fff" :setDefault="isDefault">
                        <ul>
                            <li data-id="SUCCESS">成功</li>
                            <li data-id="WITHDRAW_FAILED">失敗</li>
                            <li data-id="WITHDRAW_AUDITING">等待中</li>
                        </ul>
                    </rent-select>
                    <date-picker v-model="withdrawPeriod" :class="{'active': withdrawPeriod != ''}" placeholder="請選擇日期" format="YYYY.MM.DD"  rangeSeparator="-" range  ></date-picker>
                </div>
            </div>
            <div class="table-list withdraw" v-if="verifiedState == 5">
                <div class="table-list-title">
                    <span class="bank">提領至</span>
                    <span class="number">提領編號</span>
                    <span class="price">金額</span>
                    <span class="state">狀態</span>
                    <span class="reason">失敗原因</span>
                    <span class="date">申請提領時間</span>
                </div>
                <div class="table-list-body" v-if="verifiedState == 5">
                    <div v-show="filterEmpty" class="filter-empty">
                        <span>0 個搜尋結果</span>
                        <button class="default-button" @click="setFilterDefault">清除篩選</button>
                    </div>
                    <div v-show="withdrawListDataEmpty" class="is-empty">0 筆資料</div>
                    <ul>
                        <li v-for="(bill,index) in filterResult" :key="index">
                            <span class="bank">
                                <img :src="'../../../../../static/img/bank/'+bill.bankCode+'.png'" alt="">
                                {{bill.bankName}}
                            </span>
                            <span class="number">{{transIdEncrypt(bill.transactionId)}}</span>
                            <span class="price">$ {{toCurrency(bill.amount)}}</span>
                            <span class="state green" v-if="bill.transactionStatus == 'SUCCESS'">成功</span>
                            <span class="state red" v-if="bill.transactionStatus == 'WITHDRAW_FAILED'">失敗</span>
                            <span class="state gray" v-if="bill.transactionStatus == 'WITHDRAW_AUDITING'">等待中</span>
                            <span class="reason">{{bill.withdrawFailReason? bill.withdrawFailReason : '-'}}</span>
                            <span class="date">{{getFormatDate(bill.createdDate)}}</span>
                        </li>
                    </ul>
                </div> -->
            </div>
        </div>
    </div>
</template>
<script>
import RentSelect from '@/components/widge/RentSelect.vue';
import platformFeeInfo from '@/components/widge/modal/platformFeeInfo.vue';
import DatePicker from 'vue2-datepicker';
import storedRecord from '@/components/landlord/houseStatus/memberCenter/memberWallet/storedRecord.vue';
import recivedAccount from '@/components/landlord/houseStatus/memberCenter/memberWallet/recivedAccount.vue';
import withdrawRecord from '@/components/landlord/houseStatus/memberCenter/memberWallet/withdrawRecord.vue';
import incomeRecord from '@/components/landlord/houseStatus/memberCenter/memberWallet/incomeRecord.vue';
import { mapGetters } from 'vuex'
export default {
    data () {
        return {
            walletSelectedTab: 'STORED',
            walletTabName: {
                stored: 'STORED',
                recived: 'RECIVED',
                withdraw: 'WITHDRAW',
                income: 'INCOME',
            },
            listIsFixed: false
            // bankCardState: null,
            // withdrawState: null,
            // bankCardState: null,
            // verifiedState: 0,
            // isDefault: false,
            // withdrawPeriod: [],
            // withdrawList: [],
            // filterEmpty: false,
            // withdrawListDataEmpty: false,
            // withdrawListDataError: false,
            // isLoading: false
        }
    },
    created () {
        window.addEventListener('scroll', this.handleScroll);
    },
    destroyed () {
        window.removeEventListener('scroll', this.handleScroll);
    },
    watch: {
        $route:{
            handler: function (val) {
                if(val.query.walletType){
                    this.walletSelectedTab = val.query.walletType
                }
            },
            immediate: true,
            deep: true
        },
        walletSelectedTab: {
            handler: function (val) {
                if(this.$route.hash == '#%E9%A3%9B%E8%B1%AC%E9%8C%A2%E5%8C%85'){
                    this.$router.replace({path: 'member', query: { walletType: this.walletSelectedTab }, hash: this.$route.hash})
                    if(val == 'STORED'){
                        this.$analytics.logEvent('儲值紀錄', { screen_name: '儲值紀錄'})
                    }else if(val == 'RECIVED'){
                        this.$analytics.logEvent('收款帳戶', { screen_name: '收款帳戶'})
                    }else if(val == 'WITHDRAW'){
                        this.$analytics.logEvent('提領紀錄', { screen_name: '提領紀錄'})
                    }else if(val == 'INCOME'){
                        this.$analytics.logEvent('收益紀錄', { screen_name: '收益紀錄'})
                    }
                }
            },
            immediate: true,
            deep: true
        }
    },
    methods: {
        platformFeeEvent: function () {
            document.getElementsByClassName('member-center')[0].style.zIndex = '9'
            this.$store.dispatch('setModalStatus', {state: true, type: 'platformFeeInfo'})
            this.$analytics.logEvent('平台收費說明', { screen_name: '平台收費說明'})
        },
        handleScroll (event) {
            if(!this.isModalMode){
                let scrollTop = event.target.documentElement.scrollTop
                // console.log(scrollTop)
            
                if( scrollTop >= 255){
                    this.listIsFixed = true
                    document.getElementsByClassName('parent-frame')[0].style.zIndex = '7'
                }else{
                    document.getElementsByClassName('tool-bar-wrap')[0].style.display = 'flex'
                    document.getElementsByClassName('parent-frame')[0].style.zIndex = '7'
                    this.listIsFixed = false
                }
            }
        }
        // getTransRecord: function () {
        //     this.$store.dispatch('getTransRecord', 1)
        // },
        // getSelectId: function (value) {
        //     this.isDefault = false

        //     if( value.ref == 'bank' ){
        //         this.bankCardState = value.id
        //     }else if( value.ref == 'withdraw' ){
        //         this.withdrawState = value.id
        //     }else if( value.ref == 'bankCard' ){
        //         this.bankCardState = value.id
        //     }
        // },
        // toCurrency: function (num){
        //     var parts = num.toString().split('.');
        //     parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        //     return parts.join('.');
        // },
        // setFilterDefault: function () {
        //     this.isDefault = true
        //     this.withdrawPeriod = []
        //     this.withdrawState = null
        // },
        // getFormatDate: function (date){
        //     var formatDate = [];
        //     var date = new Date(date);
        //     // var date = new Date(Date.parse(date));
        //     //一般日期 年 月 天 時 分
        //     formatDate[0] = date.getFullYear();
        //     formatDate[1] = date.getMonth()+1;
        //     formatDate[2] = date.getDate();
        //     formatDate[3] = (Array(2).join(0)+date.getHours(-8)).slice(-2);
        //     formatDate[4] = (Array(2).join(0)+date.getMinutes()).slice(-2);
        //     formatDate[5] = (Array(2).join(0)+date.getSeconds()).slice(-2);
        //     //月及天兩位數
        //     formatDate[6] = (Array(2).join(0)+formatDate[1]).slice(-2);
        //     formatDate[7] = (Array(2).join(0)+formatDate[2]).slice(-2);
        //     // console.log(formatDate[3] )
        //     //換算時區 台灣-8
        //     // if(formatDate[3] - 8 < 0){
        //     //     formatDate[3] = 24+(formatDate[3]-8);
        //     //     formatDate[3] = (Array(2).join(0)+formatDate[3]).slice(-2);
        //     // }else{
        //     //     formatDate[3] = formatDate[3]-8;
        //     //     formatDate[3] = (Array(2).join(0)+formatDate[3]).slice(-2);
        //     // }
        //     return formatDate[0]+'.'+formatDate[6]+'.'+formatDate[7]+' '+formatDate[3]+':'+formatDate[4];
        //     // return formatDate[0]+'-'+formatDate[5]+'-'+formatDate[6]+' '+formatDate[3]+':'+formatDate[4];
        // },
        // transIdEncrypt: function (id) {
        //     return id.substr(0,5)+'...'
        // }
    },
    computed: {
        // withdrawFilterByState: function () {
        //     return this.withdrawList.filter((withdrawItem) => {
        //         if( this.withdrawState ){
        //             if( withdrawItem.transactionStatus == this.withdrawState ){
        //                 return withdrawItem
        //             }
        //         }else{
        //             return withdrawItem
        //         }
        //     });
        // },
        // filterByContractDate: function () {
        //     return this.withdrawFilterByState.filter((withdrawItem) => {
        //         if( this.withdrawPeriod[0] && this.withdrawPeriod[1] ){
        //             let withdrawDate = withdrawItem.createdDate,
        //                 filterDateStart = Date.parse(this.withdrawPeriod[0]).valueOf(),
        //                 filterDateEnd = Date.parse(this.withdrawPeriod[1]).valueOf()+86400000
        //             if( filterDateStart <= withdrawDate && withdrawDate <= filterDateEnd ){
        //                 return withdrawItem
        //             }
        //         }else{
        //             return withdrawItem
        //         }
        //     });
        // },
        // filterResult: function () {
        //      if( this.withdrawListDataEmpty == false && this.withdrawListDataError == false && this.isLoading == false ){
        //         if( this.filterByContractDate.length == 0 ){
        //             this.filterEmpty = true
        //         }else{
        //             this.filterEmpty = false
        //             return this.filterByContractDate
        //         }
        //     }
        // },
        ...mapGetters({
            isModalMode: 'GET_MODAL_MODE'
            // withdrawList: 'GET_MEMBER_TRANS_LIST',
        })
    },
    components: {
        // RentSelect,
        // NewBank,
        // DatePicker,
        platformFeeInfo,
        storedRecord,
        recivedAccount,
        withdrawRecord,
        incomeRecord
    }
}
</script>
<style lang="scss" scoped>
    .member-withdraw{
        position: relative;
        .member-withdraw-wrap{
            padding: 24px 0px;
            min-height: 520px;
            .member-withdraw-head.fixed{
                z-index: 50;
                position: fixed;
                top: 0;
                background: #fff;
                width: 500px;
                height: 80px;
                margin-left: -1px;
                .platform-fee{
                    display: none;
                }
            }
            .member-withdraw-head{
                position: relative;
                display: flex;
                align-items: center;
                // height: 44px;
                margin-bottom: 24px;
                padding: 0 30px;
                .title{
                    font-size: 20px;
                    font-weight: 500;
                    margin-right: 24px;
                }
                .wallet-tab{
                    display: flex;
                    align-items: center;
                    color: #a8a5a4;
                    li{
                        margin-right: 20px;
                        cursor: pointer;
                    }
                    li.active{
                        color: #ff9275;
                    }
                }
                .platform-fee{
                    position: absolute;
                    right: 30px;
                    display: flex;
                    align-items: center;
                    font-size: 12px;
                    cursor: pointer;
                    .info{
                        height: 24px;
                        font-size: 12px;
                        line-height: 24px;
                        color: #676362;
                        border-radius: 2px;
                    }
                    img{
                        margin-right: 2px;
                    }
                }
                // .info{
                //     display: flex;
                //     align-items: center;
                //     color: #a8a5a4;
                //     >img{
                //         width: 30px;
                //         height: 30px;
                //         margin-right: 4px;
                //     }
                // }
                // .btn-group{
                //     position: absolute;
                //     display: flex;
                //     align-items: center;
                //     right: 0px;
                //     .rent-select{
                //         width: 75px;
                //     }
                //     .mx-datepicker{
                //         width: 214px;
                //         margin-left: 16px;
                //         input{
                //             width: 100%;
                //             height: 44px;
                //             border-radius: 4px;
                //             border: solid 1px #e0dfde;
                //             color: #a8a5a4;
                //             padding: 13px 16px;
                //             box-shadow: none;
                //             margin-bottom: 0px;
                //         }
                //         .mx-icon-calendar,
                //         .mx-icon-clear{
                //             right: 14px;
                //         }
                //     }
                //     .mx-datepicker:hover,
                //     .mx-datepicker.active{
                //         input{
                //             border: 1px solid #676362 !important;
                //             color: #676362 !important;
                //         }
                //         i{
                //             color: #676362;
                //         }
                //     }
                // }
            }
            .member-withdraw-body{
                margin-bottom: 60px;
            }
            // .withdraw{
            //     position: relative;
            //     width: 1094px;
            //     border-radius: 0px;
            //     border: 0px;
            //     border-bottom: 1px solid #f0f0f0;
            //     border-top: 1px solid #f0f0f0;
            //     .table-list-body ul li .bank{
            //         display: flex;
            //         align-items: center;
            //         >img{
            //             width: 30px;
            //             height: 30px;
            //             margin-right: 10px;
            //         }
            //     }
            //     .table-list-body ul li .state{
            //         display: flex;
            //         align-items: center;
            //         justify-content: center;
            //         height: 38px;
            //         border-radius: 4px;
            //     }
            //     .table-list-body ul li .state.green{
            //         background-color: rgba(79, 181, 192, 0.08);
            //         color: #ff9275;
            //     }.table-list-body ul li .state.red{
            //         background-color: rgba(240, 90, 62, 0.1);
            //         color: #fc7171;
            //     }.table-list-body ul li .state.gray{
            //         background-color: #f6f6f6;
            //         color: #a8a5a4;
            //     }
            //     .table-list-title .bank,
            //     .table-list-body ul li .bank{
            //         position: relative;
            //         width: 126px;
            //         margin-right: 45px;
            //     }
            //     .table-list-title .number,
            //     .table-list-body ul li .number{
            //         width: 80px;
            //         margin-right: 55px;
            //     }
            //     .table-list-title .price,
            //     .table-list-body ul li .price{
            //         width: 74px;
            //         margin-right: 64px;
            //     }
            //     .table-list-title .state,
            //     .table-list-body ul li .state{
            //         width: 76px;
            //         margin-right: 85px;
            //     }
            //     .table-list-title .reason,
            //     .table-list-body ul li .reason{
            //         width: 200px;
            //         margin-right: 85px;
            //     }
            //     // .table-list-title .date,
            //     // .table-list-body ul li .date{
            //     //     width: 72px;
            //     // }
            // }
        }
        
    }
    @media screen and (max-width: 1280px) {
        .member-withdraw{
            .member-withdraw-wrap{
                .withdraw{
                    width: 1080px;
                }
            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/landlord/houseStatus/memberCenter/memberWallet/MemberWallet.vue